/** HTML elements body */
export const BODY = document.body;

/** HTML elements global header */
export const HEADER = document.getElementById('js_header');

/** HTML elements global header hamburger */
export const HAMBURGER = document.getElementById('js_hamburgerBtn');

/** HTML elements full screen overlay */
export const FULL_SCREEN_OVERLAY = document.getElementById('js_fullScreenOverlay');

/** HTML elements floating menu */
export const FLOATING_BTN = document.getElementById('js_floatingMenu');

/** HTML elements to top button */
export const TO_TOP = document.getElementById('js_toTop');

/** ドロワー/モーダル要素のスクロール可能エリアに付与するクラス名 */
export const CSS_CAN_SCROLL = 'js_canScroll';